import fetchMultiPart from '@/api/fetch-types/fetchMultipart'

interface IFileResponse {
  location: string
}

export const uploadFileService = async (formData: FormData) =>
  await fetchMultiPart<IFileResponse>('/v1/files', formData)
